<template>
  <div id="vnr-intro">
    <a href="mailto:jp@visualandrelevant.com?subject=Hey">
        <img width="70" src="../assets/vnr-bulb.png">
    </a>
    <!-- <h2>{{ msg }}</h2> -->
  </div>
</template>

<script>
export default {
  name: 'VisualRelevant',
  data() {
    return {
      msg: 'visual & relevant.',
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #vnr-intro{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    h1, h2 {
        font-weight: normal;
        margin: 0 auto;
        padding-top: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/VnrIntro.vue